// extracted by mini-css-extract-plugin
module.exports = {"suggestion":"_6f86fff9","suggestionTitle":"_4dfab619"};